import React, { useState } from 'react';
import { X, Download, FileText, CheckCircle2 } from 'lucide-react';
import { COURSES } from '../data/coursesData';

export default function BrochureModal({ isOpen, onClose }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [course, setCourse] = useState('msc-ds');
  const [downloaded, setDownloaded] = useState(false);

  if (!isOpen) return null;

  const handleDownload = (e) => {
    e.preventDefault();
    setDownloaded(true);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="glass-card"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: '520px',
          backgroundColor: '#0F2537',
          color: '#FFFFFF',
          padding: '0',
          position: 'relative',
          borderRadius: '20px',
          overflow: 'hidden',
          border: '1px solid rgba(212, 175, 55, 0.3)',
          boxShadow: '0 25px 50px rgba(0, 0, 0, 0.8)'
        }}
      >
        {/* Header */}
        <div style={{
          backgroundColor: '#07131E',
          color: '#FFFFFF',
          padding: '1.75rem 2rem',
          position: 'relative',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              background: 'rgba(255, 255, 255, 0.1)',
              border: 'none',
              color: '#FFFFFF',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <X size={18} />
          </button>

          <div style={{ display: 'flex', alignItems: 'center', gap: '0.65rem' }}>
            <FileText size={24} color="#D4AF37" />
            <div>
              <h3 style={{ fontSize: '1.35rem', fontWeight: 800, margin: 0, color: '#FFFFFF' }}>
                Download Official Prospectus
              </h3>
              <p style={{ fontSize: '0.82rem', color: '#CBD5E1', margin: 0 }}>
                CHRIST (Deemed to be University) Online Programmes 2026
              </p>
            </div>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: '2rem' }}>
          {downloaded ? (
            <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
              <div style={{
                width: '60px',
                height: '60px',
                backgroundColor: 'rgba(16, 185, 129, 0.15)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.25rem auto',
                border: '1px solid rgba(16, 185, 129, 0.3)'
              }}>
                <CheckCircle2 size={36} color="#34D399" />
              </div>
              <h4 style={{ fontSize: '1.3rem', fontWeight: 800, color: '#FFFFFF', marginBottom: '0.5rem' }}>
                Prospectus Downloaded!
              </h4>
              <p style={{ fontSize: '0.9rem', color: '#CBD5E1', lineHeight: 1.5, marginBottom: '1.5rem' }}>
                We have also emailed the detailed fee structure and course handbook to <strong>{email}</strong>.
              </p>
              <button
                onClick={() => { setDownloaded(false); onClose(); }}
                className="btn-primary"
                style={{ width: '100%' }}
              >
                Done
              </button>
            </div>
          ) : (
            <form onSubmit={handleDownload} style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
              <div>
                <label className="form-label">Full Name *</label>
                <input
                  type="text"
                  required
                  placeholder="Enter your full name"
                  className="form-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div>
                <label className="form-label">Email Address *</label>
                <input
                  type="email"
                  required
                  placeholder="name@domain.com"
                  className="form-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div>
                <label className="form-label">Mobile Number *</label>
                <input
                  type="tel"
                  required
                  pattern="[0-9]{10}"
                  placeholder="10 digit mobile number"
                  className="form-input"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div>
                <label className="form-label">Select Program Prospectus *</label>
                <select
                  className="form-input"
                  value={course}
                  onChange={(e) => setCourse(e.target.value)}
                  style={{ backgroundColor: '#07131E', color: '#FFFFFF' }}
                >
                  {COURSES.map(c => (
                    <option key={c.id} value={c.id} style={{ backgroundColor: '#0F2537' }}>{c.name} ({c.type})</option>
                  ))}
                </select>
              </div>

              <button
                type="submit"
                className="btn-primary"
                style={{ width: '100%', padding: '0.9rem', fontSize: '0.95rem', marginTop: '0.5rem' }}
              >
                Download PDF Prospectus <Download size={18} />
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
